import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import history from 'utils/history'
import { reducer as rootSlices } from './root-slices'
import { reducer as orders } from 'containers/Orders/slices'
import { reducer as steps } from 'components/Steps/slices'
import { reducer as footer } from 'components/Footer/slices'
import { reducer as refund } from 'containers/Refund/slices'
import { reducer as reclamationForm } from 'components/ReclamationContactForm/slices'
import { reducer as returnStep } from 'containers/Return/slices'
import { reducer as complaint } from 'containers/Reclamation/slices'
import { reducer as header } from 'components/Header/slices'
import { reducer as exchange } from 'containers/Exchange/slice'
import { reducer as popup } from 'components/Modal/slices'
import { reducer as scrollButton } from 'components/ScrollButton/slice'

export default function createReducer(injectedReducers = {}) {
	const appReducer = combineReducers({
		router: connectRouter(history),
		root: rootSlices,
		orders,
		steps,
		footer,
		refund,
		reclamationForm,
		returnStep,
		complaint,
		header,
		exchange,
		popup,
		scrollButton,
		...injectedReducers,
	})

	const rootReducer = (state, action) => {
		// if (action.type === 'auth/logout') {
		// 	state = undefined
		// }
		return appReducer(state, action)
	}
	return rootReducer
}
